import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import dayjs from "dayjs";
import { formatDateARG, formatMoneyPunto } from "utils/formatters";

const toMoney = (value) => Number(value) || 0;
export const PAGO_CUENTA_CORRIENTE_SHEET_NAME = "Traslado a Upro";

export const buildPagoCuentaCorrienteExcelSheet = (historial) => {
  const detalles = Array.isArray(historial?.detalles) ? historial.detalles : [];
  const rows = [
    ["Fecha de creación", historial?.createdAt ? formatDateARG(historial.createdAt) : "-"],
    ["Información general", historial?.informacionGeneral || "-"],
    ["Estado", historial?.estado || "Pendiente"],
    ["Cantidad de clientes afectados", Number(historial?.cantidadClientes) || detalles.length || 0],
    ["Monto total trasladado", `$ ${formatMoneyPunto(toMoney(historial?.montoTotal))}`],
    ["Fecha de corte", historial?.fechaFin ? formatDateARG(historial.fechaFin) : "-"],
    [],
    [
      "Nombre del cliente",
      "Apellido del cliente",
      "DNI del cliente",
      "Saldo del cliente antes del traslado",
      "Monto trasladado",
      "Saldo actual del cliente",
    ],
  ];

  detalles.forEach((item) => {
    rows.push([
      item?.nombre || "",
      item?.apellido || "",
      item?.dni || "",
      toMoney(item?.saldoAntes),
      toMoney(item?.montoPago),
      toMoney(item?.saldoActual),
    ]);
  });

  const ws = XLSX.utils.aoa_to_sheet(rows);
  ws["!cols"] = [{ wch: 24 }, { wch: 24 }, { wch: 16 }, { wch: 30 }, { wch: 24 }, { wch: 22 }];
  return ws;
};

export const downloadPagoCuentaCorrienteExcel = (historial, customFileName) => {
  if (!historial) return false;

  const ws = buildPagoCuentaCorrienteExcelSheet(historial);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, PAGO_CUENTA_CORRIENTE_SHEET_NAME);

  const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  const blob = new Blob([excelBuffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  const fileName =
    customFileName ||
    `PagoCuentaCorriente_${historial?.id || "lote"}_${dayjs().format("YYYY-MM-DD_HH-mm-ss")}.xlsx`;
  saveAs(blob, fileName);
  return true;
};
